/**
 * MTA Sequential Thinking 模块 - 顺序思考与问题解决
 * 
 * 动态代理 @modelcontextprotocol/server-sequential-thinking 的能力
 * 保持依赖更新的同时，提供 MTA 特有的增强功能
 * 
 * @version 2.0.0
 * @since 3.2.0
 */

// ================== 类型定义 ==================

export interface ThoughtInput {
  thought: string;
  nextThoughtNeeded: boolean;
  thoughtNumber: number;
  totalThoughts: number;
  isRevision?: boolean;
  revisesThought?: number;
  branchFromThought?: number;
  branchId?: string;
  needsMoreThoughts?: boolean;
}

export interface ThoughtOutput {
  thoughtNumber: number;
  totalThoughts: number;
  nextThoughtNeeded: boolean;
  branches: string[];
  thoughtHistoryLength: number;
}

// ================== 动态导入上游模块 ==================

let SequentialThinkingServerClass: any = null;

/**
 * 动态加载 SequentialThinkingServer 类
 * 这样可以保持依赖更新，同时避免启动时的硬依赖
 */
async function loadSequentialThinkingServer() {
  if (!SequentialThinkingServerClass) {
    try {
      // 动态导入 npm 包的 lib 模块
      // @ts-ignore - 该包的类型定义在运行时动态加载
      const module = await import('@modelcontextprotocol/server-sequential-thinking');
      // @ts-ignore - 动态模块属性访问
      SequentialThinkingServerClass = module.SequentialThinkingServer;
    } catch (error) {
      console.error('无法加载 @modelcontextprotocol/server-sequential-thinking:', error);
      throw new Error('顺序思考模块加载失败，请确保已安装 @modelcontextprotocol/server-sequential-thinking');
    }
  }
  return SequentialThinkingServerClass;
}

// ================== 单例管理器 ==================

let thinkingServer: any = null;

/**
 * 获取顺序思考服务器单例
 */
async function getThinkingServer() {
  if (!thinkingServer) {
    const Server = await loadSequentialThinkingServer();
    thinkingServer = new Server();
  }
  return thinkingServer;
}

// ================== MCP 工具处理函数 ==================

/**
 * 顺序思考工具
 */
export async function sequentialThinking(args: ThoughtInput): Promise<any> {
  const server = await getThinkingServer();
  const result = server.processThought(args);

  // 检查是否有错误
  if (result.isError) {
    return result;
  }

  // 解析 JSON 响应
  const parsedContent = JSON.parse(result.content[0].text);

  return {
    content: [{
      type: 'text',
      text: JSON.stringify(parsedContent, null, 2)
    }]
  };
}
